import { Navigate, useLocation } from "react-router";
import { useAuth } from "../contexts/AuthContext";
import { usePermission } from "../contexts/PermissionContext";
import { Loading } from "./Loading";
import { Box, Typography } from "@mui/material";
import { LockOutlined } from "@mui/icons-material";
import { Status } from "../constants/status";
import { AppRoutes } from "../constants/appRoutes";

const AccessDenied = () => (
  <Box
    sx={{
      p: 4,
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      mt: 10,
    }}
  >
    <Box
      sx={{
        p: 2,
        borderRadius: "50%",
        bgcolor: "error.main",
        color: "white",
        mb: 3,
      }}
    >
      <LockOutlined />
    </Box>
    <Typography
      variant="h4"
      color="text.primary"
      gutterBottom
      sx={{ fontWeight: 800 }}
    >
      Access Denied
    </Typography>
    <Typography color="text.secondary" sx={{ fontWeight: 500 }}>
      You do not have the required permissions to view this sector.
    </Typography>
  </Box>
);

export const ProtectedRoute = ({ children, permission, logic = "AND" }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const { hasPermission } = usePermission();
  const location = useLocation();

  if (loading) {
    return <Loading message="Authenticating User..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to={AppRoutes.LOGIN} replace state={{ from: location }} />;
  }

  if (user?.status === Status.PENDING) {
    return <Navigate to={AppRoutes.PENDING_APPROVAL} replace />;
  }

  if (permission && !hasPermission(permission, { logic })) {
    return <AccessDenied />;
  }

  return children;
};
